// Variantes WebP de producto. El backend (app/core/storage.py) guarda la URL de 1600px
// (`<base>_1600.webp`) y deja las hermanas `<base>_400.webp` y `<base>_800.webp`.
// Para imagenes sin migrar (png/jpg antiguas o externas) todo devuelve la URL original:
// nunca se arma una URL que pueda no existir.

const PRIMARY = /_1600\.webp(\?.*)?$/;

// El bucket R2 se sirve por un dominio propio con cache de Cloudflare; las URLs guardadas en BD
// siguen apuntando al host `r2.dev` (sin cache, con rate limit), asi que se reescribe al renderizar.
const CDN_BASE = (process.env.REACT_APP_IMG_CDN || 'https://cdn.armaloperu.com').replace(/\/$/, '');
// Host publico del bucket (el que quedo guardado en la base de datos). Se configura por tienda:
// REACT_APP_R2_HOST=pub-xxxxxxxx.r2.dev. Por defecto, el de Armalo.
const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const R2_HOST = escapeRegExp(process.env.REACT_APP_R2_HOST || 'pub-b7640b616bc1475fbbefbc9789c8c779.r2.dev');
const R2_DEV_HOST = new RegExp(`^https://${R2_HOST}`);

/** Reescribe el host r2.dev del bucket de Armalo al CDN. Cualquier otra URL queda igual. */
export const cdnUrl = (url) =>
  typeof url === 'string' && CDN_BASE ? url.replace(R2_DEV_HOST, CDN_BASE) : url;

export const isOptimized = (url) => typeof url === 'string' && PRIMARY.test(url);

/** URL de un ancho concreto (400 | 800 | 1600). Sin migrar -> la misma URL (con CDN si aplica). */
export const variantUrl = (url, width) =>
  isOptimized(url) ? cdnUrl(url.replace(PRIMARY, `_${width}.webp`)) : cdnUrl(url);

/** Valor de `srcSet` o undefined si la imagen no tiene variantes. */
export const productSrcSet = (url, widths = [400, 800, 1600]) =>
  isOptimized(url) ? widths.map((w) => `${variantUrl(url, w)} ${w}w`).join(', ') : undefined;

/** Props listos para esparcir en <img>: src fijo + srcSet/sizes si aplica. */
export const productImgProps = (url, sizes, widths = [400, 800, 1600]) => {
  const srcSet = productSrcSet(url, widths);
  return srcSet
    ? { src: variantUrl(url, widths[Math.min(1, widths.length - 1)]), srcSet, sizes, decoding: 'async' }
    : { src: cdnUrl(url), decoding: 'async' };
};
